import script from "./ContentTypeSelectionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentTypeSelectionModal.vue?vue&type=script&setup=true&lang=ts"

import "./ContentTypeSelectionModal.vue?vue&type=style&index=0&id=2a8e1622&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a8e1622"]])

export default __exports__